import React from "react";
import Layout from "../../components/layout";
import Divider from "../../components/divider";

export default function () {
  return (
    <Layout>
      <div className="mt-24"></div>
      <div className="container mx-auto px-8">
        <h2
          style={{ textShadow: "4px 4px 0 rgba(239,68,68,0.2)" }}
          className="text-red-500 text-4xl font-bold"
        >
          Certificate in Aviation & Hospitality (CAH)
        </h2>
        <h3 className="font-bold text-xl text-gray-700 mt-4">
          Duration: 6 months
        </h3>
        <ul>
          <li>5 days/week</li>
          <li>2 hours/day</li>
        </ul>
        <h3 className="font-bold text-xl text-gray-700 mt-4">
          Eligibility Criteria:
        </h3>
        <ul>
          <li>
            Qualification: 12th Appd or Pass/ Pursuing Graduation/ Graduate
          </li>
          <li>Age: 18 to 25 years</li>
          <li>Good in English Communication Skill</li>
          <li>Pleasing Personality</li>
          <li>Selection will be on basis of Personal Interview</li>
        </ul>
        <h3 className="font-bold text-xl text-gray-700 mt-4">
          Benefits to Join the Course –
        </h3>
        <h3 className="font-bold text-gray-700 mt-4">
          Aviation Industry is growing enormously not only in India but also
          globally.
        </h3>
        <p>
          India’s domestic Aviation market has made its way to the third largest
          aviation market in the world while the overall civil aviation market
          is set to become the third largest in world by the end of 2022. By
          2022, the Indian airports are expected to witness a growth in
          passenger traffic up to 421 million. Reports state that by the end of
          May 2022, there are 588 airplanes in the fleet of Indian airlines that
          are in-service. But this number is expected to grow to 1100 planes by
          the end of 2027. Several government connectivity initiatives like UDAN
          (Ude Desh ka Aam Nagrik) have been started by PM to make flying
          cheaper and accessible to common man. The hospitality and travel
          industries are also generating immense demands for quality personnel.
          This course has been designed by the industry experts for the pupil
          who can grab the necessary skills within a short period of time, i.e,
          only 6 months.
        </p>
        <h3 className="font-bold text-xl text-gray-700 mt-4">
          Course Contents –
        </h3>
        <ul>
          <li>Advance English</li>
          <li>Self Development</li>
          <li>Grooming</li>
          <li>Aviation</li>
          <li>Hospitality Management</li>
          <li>Tour n Travel</li>
          <li>Interview Skill</li>
          <li>Organisational Management</li>
          <li>Swimming</li>
        </ul>
      </div>
      <Divider />
    </Layout>
  );
}
